<template>
    <div class="down_ios">
         <div class="box">
              <p class="down_tip1">点击复制在浏览器下载</p>
              <div class="down_url">
                   <textarea  class="url" :disabled="true" v-model="downUrl"></textarea>
              </div>
              <div class="btn">
                   <button  @click="cancel">取消</button>
                   <button v-clipboard:copy="downUrl"  v-clipboard:success="firstCopySuccess" v-clipboard:error="firstCopyError">复制</button>
              </div>
         </div>
    </div>
</template>
<script>
    export default {
        props:{
            downUrl: {// 控制显示是否有自定义按钮
                type: String,
                default: ''
            },
        },
        components: {
        },
        data () {
            return {
              
            };
        },
        created () {
      
        },
        methods: {
            cancel(){
                this.$emit('cancelDown','cancel')
            },
            firstCopySuccess(e) {
                // this.$Toast("复制成功!");
                this.$emit('cancelDown','success')
            },
            firstCopyError(e) {
                console.log("copy arguments e:", e);
                this.$Toast("复制失败!");
            }
        }
    };
</script>
<style lang="less" scoped>
.down_ios{
    width:100%;
    height:100%;
    position: fixed;
    left:0;
    top:0;
    z-index: 99999999999;
    background:rgba(0,0,0,.5);
    .box{
        width:270px;
        height:160px;
        background-color:#fff;
        position: absolute;
        left:50%;
        top:50%;
        transform: translate(-50%,-50%);
        border-radius: 10px;
        text-align: center;
        .down_tip1{
            font-size:16px;
            color:#333;
            margin-top:30px;
        }
        .down_url{
            padding:0 10px;
            word-wrap:break-word;
           
            margin-top:20px;
            .url{
                width:100%;
                height:30px;
                background-color:#efefef;
                border-radius: 3px;
                // text-align: center;
                line-height: 30px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow:ellipsis;
                font-size:14px;
                border:0;
                outline: none;
            }
            
        }
        .btn{
            width:100%;
            display:flex;
            flex-direction: row;
            align-items: center;
            height:40px;
            margin-top:20px;
            button{
                display: inline-block;
                width:50%;
                text-align: center;
                font-size:14px;
                height:100%;
                border-right:1px solid #efefef;
                line-height: 40px;
                border:0;
                outline: none;
                background-color: #fff;
                border-radius: 6px;
            }
            button:nth-child(2){
                color:#36B374;
            }
        }
    }
}
</style>
